export const dbOptions = {
  name: 'keyval-store',
  version: 1,
  /** 最大存储限制, -1不限制 */
  maxStorage: -1,
  /** 单条数据最大存储限制, -1不限制 */
  maxDataSize: -1,
}

export const CHECK_MAX_STORAGE_MESSAGE = 'check_max_storage_message'

// 当前版本
export const CURRENT_VERSION = 4

// asset表字段
export const ASSET_TABLE_COLUMNS = 'id,data,size,updated_at'
